/**
 * Define and Export Action Types
 */

export const FORM_CLEAR = 'FORM_CLEAR'
export const FORM_REGISTER_INPUTS = 'FORM_REGISTER_INPUTS'
export const FORM_INPUT_CHANGE = 'FORM_INPUT_CHANGE'
export const FORM_INPUT_FOCUS = 'FORM_INPUT_FOCUS'
export const FORM_INPUT_BLUR = 'FORM_INPUT_BLUR'
export const FORM_VALIDATE_REQUEST = 'FORM_VALIDATE_REQUEST'
export const FORM_VALIDATE_PASS = 'FORM_VALIDATE_PASS'
export const FORM_VALIDATE_FAIL = 'FORM_VALIDATE_FAIL'
export const FORM_SUBMIT_REQUEST = 'FORM_SUBMIT_REQUEST'
export const FORM_SUBMIT_PASS = 'FORM_SUBMIT_PASS'
export const FORM_SUBMIT_FAIL = 'FORM_SUBMIT_FAIL'
export const FORM_BUTTON_PASS = 'FORM_BUTTON_PASS'
export const FORM_BUTTON_FAIL = 'FORM_BUTTON_FAIL'
